export default function TermsAndPrivacyPage() {
  return (
    <>
      <div>Awesome mode terms and privacy located in misccomponents</div>
    </>
  );
}
